import { FC, useEffect } from "react";
import { Loader } from "@/components";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useNavigate } from "react-router-dom";
import { useSingleChallengeBasedOnGame } from "@/features/challenge/hooks/useSingleChallengeBasedOnGame";

const CounterStrikeChallenge: FC = (): JSX.Element => {
  const navigate = useNavigate();

  const { slug, loading } = useSingleChallengeBasedOnGame(
    brand.tenantId,
    "finished",
    "CSGO"
  );

  useEffect(() => {
    if (!loading && slug) {
      navigate(`/challenges/${slug}`);
    }
  }, [slug]);

  if (loading) {
    return <Loader />;
  }

  return null;
};

export default CounterStrikeChallenge;
